




































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import NaviItemLinkForSpOnGeneral from "@/common/components/organisms/header/general/NaviItemLinkForSpOnGeneral.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconHeart,
    IconHistoryLog,
    NaviItemLinkForSpOnGeneral
  }
})
export default class TheHeaderNaviOfSubMenu extends Vue {
  @Prop({ type: String, required: true }) iconColor!: string;
}
